import { Button, Col, Row } from "react-bootstrap"
import ThongTinGiaDinh from "./ThongTinGiaDinh"
import TextField from "../../../../component/TextField"
import { useContext, useEffect, useState } from "react"
import { getJsonGenerateForms } from "../../../../utils/ServicesUtils"
import ModalTimKiemBenhNhan from "src/app/modules/component/modal-tim-kiem-benh-nhan/ModalTimKiemBenhNhan"
import { getPatientId } from "../../../services/TiepNhanServices"
import { convertDataBenhNhan } from "../../../util/FunctionUtil"
import { CODE, ID_DANG_KY_KHAM, KEY_DS_DANH_MUC_TIEP_DON, VARIABLE_STRING } from "src/app/modules/utils/Constant"
import { CODE_DOI_TUONG } from "../../../constants/PhanHeTiepNhan"
import { toast } from "react-toastify"
import { useAppContext } from "src/app/modules/appContext/AppContext"
import useIndexDBValue from "src/app/hook/useIndexDBValue"
import { IDanhSachDanhMuc } from "../../../models/TiepDonModel"
import { PhanHeTiepNhanContext } from "../../../PhanHeTiepNhan"
import { useFormikContext } from "formik"

const JSON_CODE = {
  FAMILYRECORDS1: "familyRecords1",
  FAMILYRECORDS2: "familyRecords2",
  GUARDIANRECORDS: "guardianRecords",
};

const  TabGiaDinh = () => {
  const { setIsLoading } = useAppContext();
  const {value: danhSachDanhMuc} = useIndexDBValue<IDanhSachDanhMuc>({
	key: KEY_DS_DANH_MUC_TIEP_DON
  });
  const { setThongTinBenhNhan, thongTinBenhNhan, setOrderMain } = useContext(PhanHeTiepNhanContext);
  const { setValues } = useFormikContext<any>();

  const [openDSBenhNhanDialog, setOpenDSBenhNhanDialog] = useState(false);
  const [dataGenerate, setDataGenerate] = useState<any>();
  const [searchObject, setSearchObject] = useState<any>();

  useEffect(() => {
    handleGetJsonGenerateForms();
  }, []);

  const handleChangeValueSearch = (e: any) => {
    const {name, value} = e.target;
    setSearchObject({...searchObject, [name]: value});
  }

  const handleOpenDSBenhNhanDialog = () => {
    setOpenDSBenhNhanDialog(true);
  }

  const handleGetJsonGenerateForms = async () => {
    try {
      let codes = `${JSON_CODE.FAMILYRECORDS1},${JSON_CODE.FAMILYRECORDS2},${JSON_CODE.GUARDIANRECORDS}`
      let { data } = await getJsonGenerateForms(codes);
      setDataGenerate(data?.data);
    } catch (error) {
      console.error(error);
    }
  }

  const getPatientData = async (id: string) => {
      try {
        setIsLoading(true);
        const { data } = await getPatientId(id);

        if (CODE.SUCCESS === data?.code) {
          const dataConverted = convertDataBenhNhan({
            patient: data?.data || {},
            visit: {
              [VARIABLE_STRING.DOI_TUONG]:
                danhSachDanhMuc?.listDoiTuong?.find(
                  (item) => item?.code === CODE_DOI_TUONG.YEU_CAU
                ) || null,
              visitType: danhSachDanhMuc?.listDKKham.find(
                (item: any) => item?.id === ID_DANG_KY_KHAM.KHAM_BENH
              ),
            },
          });
          setValues?.(dataConverted);
          setOrderMain(null);
          setThongTinBenhNhan({
            ...thongTinBenhNhan,
            isExamined: false,
            isMedicalExamSvcPaid: false,
          });
        } else {
          toast.warning("Xảy ra lỗi, vui lòng thử lại!");
        }
      } catch (error) {
        toast.warning("Xảy ra lỗi, vui lòng thử lại!");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

  return (
		<Row className="spaces p-12 align-items-stretch">
			<Col xl="3">
				<ThongTinGiaDinh
					title="Thông tin người nhà 1"
					formName={JSON_CODE.FAMILYRECORDS1}
					dataGenerate={JSON.parse(
						(dataGenerate?.[JSON_CODE.FAMILYRECORDS1] as string) || '{}'
					)}
				/>
			</Col>

			<Col xl="3">
				<ThongTinGiaDinh
					title="Thông tin người nhà 2"
					formName={JSON_CODE.FAMILYRECORDS2}
					dataGenerate={JSON.parse(
						(dataGenerate?.[JSON_CODE.FAMILYRECORDS2] as string) || '{}'
					)}
				/>
			</Col>

			<Col xl="3">
				<ThongTinGiaDinh
					title="Thông tin người nuôi dưỡng, giám hộ"
					formName={JSON_CODE.GUARDIANRECORDS}
					dataGenerate={JSON.parse(
						(dataGenerate?.[JSON_CODE.GUARDIANRECORDS] as string) || '{}'
					)}
				/>
			</Col>

			<Col xl="3">
				<div className="tt-gia-dinh">
					<div className="title">Người nhà bệnh nhân</div>
					<div className="content spaces py-8 px-16">
						<div className="w-100">
							<TextField
								label="Mã BN"
								name="code"
								value={searchObject?.code}
								onChange={handleChangeValueSearch}
								labelClassName="ms-0 min-w-75px"
								className="spaces mb-3"
							/>
							<TextField
								label="Tên BN"
								name="personName"
								value={searchObject?.personName}
								onChange={handleChangeValueSearch}
								labelClassName="ms-0 min-w-75px"
								className="spaces mb-3"
							/>
							<div className="text-center">
								<Button className="btn-flex" onClick={handleOpenDSBenhNhanDialog}>
									<i className="bi bi-search"></i>
									Tìm BN
								</Button>
							</div>
						</div>
					</div>
				</div>
			</Col>

			{openDSBenhNhanDialog && (
				<ModalTimKiemBenhNhan
					open={openDSBenhNhanDialog}
					handleClose={() => setOpenDSBenhNhanDialog(false)}
					objectSearchBN={searchObject}
					setPatientSelectedId={(id: string) => {
						getPatientData(id);
					}}
          		/>
			)}
		</Row>
  );
}

export default TabGiaDinh